import { observable, action } from 'mobx'
import { IMultiLocationInventory } from '@getgreenline/homi-shared'

export class CreatePOReceipt {
  @observable
  lowStockProducts: IMultiLocationInventory[] = []

  @observable
  selectedLowStockProductIds: string[] = []

  @observable
  loadingLowStockProducts = false

  @action
  setLowStockProducts(lowStockProducts: IMultiLocationInventory[]) {
    this.lowStockProducts = lowStockProducts
  }

  @action
  setSelectedLowStockProductIds(selectedLowStockProductIds: string[]) {
    this.selectedLowStockProductIds = selectedLowStockProductIds
  }

  @action
  toggleLoadingLowStockProducts() {
    this.loadingLowStockProducts = !this.loadingLowStockProducts
  }
}
